import { useNavigate } from "react-router-dom";
import { Eye, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const ImpersonationBanner = () => {
  const { user, stopEmulate } = useAuth();
  const navigate = useNavigate();
  if (!user?.impersonated_by) return null;
  return (
    <div data-testid="impersonation-banner" className="sticky top-0 z-[2000] bg-[#9A3412] text-white px-4 py-2 flex items-center justify-center gap-3 font-mono text-[11px] uppercase tracking-widest">
      <Eye className="h-3.5 w-3.5" />
      Viewing as {user.name || user.email}
      <button
        data-testid="return-to-admin"
        onClick={async () => { await stopEmulate(); navigate("/admin/users"); }}
        className="ml-2 inline-flex items-center gap-1 bg-white/20 hover:bg-white/30 px-2.5 py-1 transition-colors"
      >
        <X className="h-3 w-3" /> Return to admin
      </button>
    </div>
  );
};
